import { Controller } from "@hotwired/stimulus"

// The preview output panel is a Turbo Frame the server rebuilds on every run, so
// the choice cannot live on the element it just replaced. Keyed per file layout,
// the same way Cup::Tabs remembers the active tab and Cup::Disclosure its own.
//
// Hiding is done by the group-data variant on the decline lines, not by touching
// each one: one attribute on this root, and the browser does the rest.
export default class extends Controller {
  static targets = ["checkbox"]
  static values = { restoreKey: String }

  connect() {
    const stored = sessionStorage.getItem(this.storageKey)
    this.apply(stored === null ? true : stored === "shown")
  }

  toggle(event) {
    this.apply(event.target.checked)
  }

  apply(shown) {
    this.element.setAttribute("data-declines", shown ? "shown" : "hidden")
    if (this.hasCheckboxTarget) this.checkboxTarget.checked = shown
    sessionStorage.setItem(this.storageKey, shown ? "shown" : "hidden")
  }

  get storageKey() {
    return `cup:preview-declines:${this.restoreKeyValue}`
  }
}
